import { ReactNode } from 'react';

const AdminNavItem = ({ href, children }: { href: string; children: ReactNode }) => {
  return (
    <li>
      <a
        className='bg-gray-100 hover:bg-gray-200 text-black font-bold px-2 py-3 md:px-6 md:py-4 flex items-center border'
        href={href}
      >
        {children}
      </a>
    </li>
  );
};

export const AdminNav = () => {
  return (
    <nav className='p-4'>
      <ul className='whitespace-nowrap flex text-sm box-border overflow-x-scroll'>
        <AdminNavItem href={`${import.meta.env['VITE_LEGACY_APP_URL']}/admin`}>Home</AdminNavItem>
        <AdminNavItem href={`/platform/admin/organizations`}>Organizations</AdminNavItem>
        <AdminNavItem href={`/platform/admin/projects`}>Projects</AdminNavItem>
        <AdminNavItem href={`/platform/admin/introductions`}>Introductions</AdminNavItem>
        <AdminNavItem href={`/platform/admin/professionals`}>Professionals</AdminNavItem>
        <AdminNavItem href={`${import.meta.env['VITE_LEGACY_APP_URL']}/admin/representative`}>
          Representatives
        </AdminNavItem>
        <AdminNavItem href={`${import.meta.env['VITE_LEGACY_APP_URL']}/admin/partner`}>
          Partners
        </AdminNavItem>
        <AdminNavItem href={`${import.meta.env['VITE_LEGACY_APP_URL']}/admin/cohorts`}>
          Cohorts
        </AdminNavItem>
        <AdminNavItem href={`${import.meta.env['VITE_LEGACY_APP_URL']}/admin/team-automatch`}>
          Team&nbsp;Automatch
        </AdminNavItem>
        <AdminNavItem href={`/platform/admin/job-postings`}>Job&nbsp;Postings</AdminNavItem>
        <AdminNavItem href={`/platform/admin/events`}>Events</AdminNavItem>
        <AdminNavItem href={`/platform/admin/community-wins`}>Community&nbsp;Wins</AdminNavItem>
        <AdminNavItem href={`/platform/admin/community-announcements`}>
          Community&nbsp;Announcements
        </AdminNavItem>
        <AdminNavItem href={`/platform/admin/funding-opportunities`}>
          Funding&nbsp;Opportunities
        </AdminNavItem>
        <AdminNavItem href={`/platform/admin/meetings`}>Meetings</AdminNavItem>
      </ul>
    </nav>
  );
};
